import React from 'react'
import styled from '@emotion/styled'
import { Skeleton } from '@mui/material'
import { GenericLoader, type LoadingProps } from '@edge/spark/ui-mui'

const SingleNumberSkeleton = styled(Skeleton)`
    height: 34px;
    color: #303030;
    margin: 5px 0px;
`

export const SingleNumberLoader: React.FC<LoadingProps> = ({ loading, width, children }: LoadingProps) => {
    return (
        <GenericLoader loading={loading} SkeletonComponent={SingleNumberSkeleton} skeletonProps={{ width }}>
            {children}
        </GenericLoader>
    )
}
